import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tabs,
  Upload,
  message,
  Switch,
} from "antd";
import {
  NON_EMPTY_REGEX,
  STATUS_CODE,
  countryList,
  AwardList,
  CountryData,
} from "common/Constants";
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-number-input";
import styled from "@emotion/styled";
import {
  getBandList,
  getClientid,
  getLocations,
  getRoleList,
  getUserList,
  getAllDepartmentList,
  getUserInfo,
} from "redux/selectors";
import { connect } from "react-redux";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { CALL_API } from "common/API";
import { setRoleList, setUserList } from "redux/actions";
import { bindActionCreators } from "redux";
import { chain, flatMap, isEmpty, filter, find } from "lodash";
import TabPane from "antd/lib/tabs/TabPane";
import FormModal from "./FormModal";
import SelectTable from "../molecules/EditEmployeeRole";
import COLORS from "common/Colors";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
`;

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }
`;

const EditProfileBox = styled.div`
  .ant-tabs-nav {
    padding-left: 10px;
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }
`;

function generateUniqueId() {
  const randomNumber = Math.random().toString(36).substr(2, 9);
  const timestamp = Date.now();
  const uniqueId = randomNumber + timestamp;
  return uniqueId;
}

function EditProfile({
  updateState,
  setUpdateState,
  EmployeeDetails,
  userList,
  roleList,
  ClientId,
  bandList,
  updateUserList,
  locationList,
  pageName,
  allDepartmentList,
  userInfo,
  saveRoleList,
}) {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const { Option } = Select;
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [showLoader, toggleLoader] = useState(false);
  const [employeeStatusId, setEmployeeStatusId] = useState("1");
  const employeesList = userList?.map((user) => user.userid);
  const [activeTab, setActiveTab] = useState("0");
  const [selectedRoleId, setSelectedRoleId] = useState([]);
  console.log("selectedRoleId", selectedRoleId, roleList);
  const [baseLocation, setBaseLocation] = useState("");
  const [baseDepartment, setBaseDepartment] = useState("");
  const [selectAllRoleChecked, setSelectAllRoleChecked] = useState(false);

  const getMaxLengthByCountry = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.phone_length : null;
  };

  useEffect(() => {
    const {
      userid = "",
      startdate = "",
      dateofbirth = "",
      enddate = "",
      bandname = "",
      bandid = "",
      overtimestatus = "",
      salary = "",
      password = "",
      profileurl = "",
      employeenumber = "",
      gender = "",
      maritalstatus = "",
      nationality = "",
      roleid = "",
      nssf = "",
      national_id = "",
      krapin = "",
      sharegnum = "",
      driverslicense = "",
      contract = "",
      address = "",
      phoneno = "",
      companyname = "",
      jobtitle = "",
      professionalsince = "",
      hireddate = "",
      probationstartdate = "",
      probationenddate = "",
      contractstartdate = "",
      contractenddate = "",
      relevant = "",
      employeesponser = "",
      statusname = "",
      jobdescription = "",
      emergencycontactname = "",
      emergencycontactnumber = "",
      employementtype = "",
      employeeid = "",
      initial,
      firstname,
      lastname,
      salutation,
      educationdetails,
      workexperience,
      professionalcertifications,
      practicaltrainings,
      lastpromotionlevel,
      lastpromotiondate,
      reportingmanager,
    } = EmployeeDetails;

    setFormValues({
      user_id: userid,
      gender: gender,
      dateof_birth: dateofbirth ? moment(dateofbirth, "YYYY-MM-DD") : null,
      password: password,
      maritalstatus: maritalstatus,
      nationality: nationality,
      start_date: startdate ? moment(startdate, "YYYY-MM-DD") : null,
      end_date: enddate ? moment(enddate) : "",
      bandName: bandname,
      bandid: bandid,
      overtime: overtimestatus,
      employeenumber: employeenumber,
      salary: salary,
      employementtype: employementtype,
      profile_url: profileurl !== ("" || null || undefined) ? profileurl : null,
      role_id: roleid,
      nssf: nssf,
      national_id: national_id,
      krapin: krapin,
      sharegnum: sharegnum,
      driverslicense: driverslicense,
      contract: contract,
      address: address,
      phoneno: phoneno,
      companyname: companyname,
      jobtitle: jobtitle,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      probationstartdate: probationstartdate
        ? moment(probationstartdate, "YYYY-MM-DD")
        : null,
      probationenddate: probationenddate
        ? moment(probationenddate, "YYYY-MM-DD")
        : null,
      contractstartdate: contractstartdate
        ? moment(contractstartdate, "YYYY-MM-DD")
        : null,
      contractenddate: contractenddate
        ? moment(contractenddate, "YYYY-MM-DD")
        : null,
      relevent: relevant,
      employeesponser: employeesponser,
      employeestatus: statusname,
      status_id: employeeStatusId,
      description: jobdescription,
      emergencycontactname: emergencycontactname,
      emergencycontactnumber: emergencycontactnumber,
      employeeid: employeeid,
      initial: initial,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      lastpromotionlevel: lastpromotionlevel,
      reportingmanager: reportingmanager,
      lastpromotiondate: lastpromotiondate
        ? moment(startdate, "YYYY-MM-DD")
        : null,
      educationdetails:
        educationdetails?.length !== 0
          ? educationdetails
          : [
              {
                institutename: "",
                fromdate: "",
                todate: "",
                exambody: "",
                awarded: "",
              },
            ],
      workexperience:
        workexperience?.length !== 0
          ? workexperience
          : [
              {
                companyname: "",
                fromdate: "",
                todate: "",
                jobtitle: "",
                relevnt: "",
                jobdescription: "",
              },
            ],
      professionalcertifications:
        professionalcertifications?.length !== 0
          ? professionalcertifications
          : [{ certificationtype: "", fromdate: "", todate: "", remarks: "" }],
      practicaltrainings:
        practicaltrainings.length !== 0
          ? practicaltrainings
          : [
              {
                organisationname: "",
                fromdate: "",
                todate: "",
                positionheld: "",
                tasksperformed: "",
              },
            ],
    });

    const transformedDetails = (data) =>
      data?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = moment(fromdate).isValid()
          ? moment(fromdate)
          : "";
        const formattedToDate = moment(todate).isValid() ? moment(todate) : "";
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });

    form.setFieldsValue({
      user_id: userid,
      password: password,
      gender: gender,
      dateof_birth: dateofbirth ? moment(dateofbirth, "YYYY-MM-DD") : null,
      maritalstatus: maritalstatus,
      nationality: nationality,
      start_date: startdate ? moment(startdate, "YYYY-MM-DD") : null,
      end_date: enddate ? moment(enddate) : "",
      bandid: bandid,
      overtime: overtimestatus,
      salary: salary,
      employeenumber: employeenumber,
      profile_url: profileurl != ("" || null || undefined) ? profileurl : null,
      role_id: roleid,
      nssf: nssf,
      national_id: national_id,
      krapin: krapin,
      sharegnum: sharegnum,
      driverslicense: driverslicense,
      contract: contract,
      address: address,
      employementtype: employementtype,
      phoneno: phoneno,
      companyname: companyname,
      jobtitle: jobtitle,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      probationstartdate: probationstartdate
        ? moment(probationstartdate, "YYYY-MM-DD")
        : null,
      probationenddate: probationenddate
        ? moment(probationenddate, "YYYY-MM-DD")
        : null,
      contractstartdate: contractstartdate
        ? moment(contractstartdate, "YYYY-MM-DD")
        : null,
      contractenddate: contractenddate
        ? moment(contractenddate, "YYYY-MM-DD")
        : null,
      relevent: relevant,
      employeesponser: employeesponser,
      employeestatus: statusname,
      description: jobdescription,
      emergencycontactnumber: emergencycontactnumber,
      emergencycontactname: emergencycontactname,
      employeeid: employeeid,
      initial: initial,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      lastpromotionlevel: lastpromotionlevel,
      lastpromotiondate: lastpromotiondate
        ? moment(startdate, "YYYY-MM-DD")
        : null,
      reportingmanager: reportingmanager,
      educationdetails:
        educationdetails?.length !== 0
          ? transformedDetails(educationdetails)
          : [
              {
                institutename: "",
                fromdate: "",
                todate: "",
                exambody: "",
                awarded: "",
              },
            ],
      workexperience:
        workexperience?.length !== 0
          ? transformedDetails(workexperience)
          : [
              {
                companyname: "",
                fromdate: "",
                todate: "",
                jobtitle: "",
                relevnt: "",
                jobdescription: "",
              },
            ],
      professionalcertifications:
        professionalcertifications?.length !== 0
          ? transformedDetails(professionalcertifications)
          : [{ certificationtype: "", fromdate: "", todate: "", remarks: "" }],
      practicaltrainings:
        practicaltrainings.length !== 0
          ? transformedDetails(practicaltrainings)
          : [
              {
                organisationname: "",
                fromdate: "",
                todate: "",
                positionheld: "",
                tasksperformed: "",
              },
            ],
    });
  }, [EmployeeDetails]);

  const getCountryCodeByName = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.code : null;
  };

  const validateEmployeeId = (rule, value) => {
    if (EmployeeDetails?.userid === value) {
      return Promise.resolve();
    } else if (value && employeesList.includes(value)) {
      return Promise.reject(t("User ID already exist"));
    }
    return Promise.resolve();
  };

  const onFinish = () => {
    const currentFormValues = form.getFieldValue();
    const updatedFormValues = { ...currentFormValues, selectedRoleId };
    setFormValues(updatedFormValues);
  };

  const uploadFile = async (value) => {
    const { file } = value;
    try {
      if (!isEmpty(file)) {
        await CALL_API(`upload-userdocuments/${ClientId}`, "post", {
          userId: EmployeeDetails?.userid,
          name: file.name,
          type: file.type,
          uniqueId: file.response.uniqueId,
          content: file.response.base64Data,
        });
      }
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      { fetch_master_data }
    );
    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
      saveRoleList(roleList);
    }
  };

  const { getPermissionById } = queryKeys;
  const { key, url } = getPermissionById(ClientId, EmployeeDetails?.roleid[0]);
  const { data } = useFetch(key, url);
  const permissionList = data?.response?.data[0]?.menuList;

  const handlepremissionsubmit = async () => {
    const { code } = await CALL_API(
      `owner-roles/${ClientId}/${EmployeeDetails?.roleid[0]}`,
      "patch",
      {
        rolename: `${formValues?.firstname} ${formValues?.lastname}`,
        location: [baseLocation],
        menuList: permissionList,
        rolestatus: "Enabled",
        department: [EmployeeDetails?.basedepartmentid],
        statusId: formValues?.status_id,
      }
    );
    if (STATUS_CODE.SUCCESS === code) {
      getRoleList();
    }
  };

  const handlesubmit = async () => {
    try {
      toggleLoader(true);
      let userId = form.getFieldValue("user_id");
      let splitUserId = userId.split("@");
      let userIdWithoutDomain = splitUserId[0];
      const {
        user_id,
        start_date,
        password,
        gender,
        dateof_birth,
        nationality,
        maritalstatus,
        overtime,
        salary,
        nssf,
        national_id,
        employeenumber = "",
        krapin,
        sharegnum,
        driverslicense,
        contract,
        address,
        phoneno,
        companyname,
        jobtitle,
        professionalsince,
        hireddate,
        relevent,
        employeesponser,
        employeestatus,
        description,
        emergencycontactname,
        emergencycontactnumber,
        employeeid,
        initial,
        firstname,
        lastname,
        salutation,
        lastpromotionlevel,
        lastpromotiondate,
        educationdetails,
        workexperience,
        professionalcertifications,
        employementtype,
        probationenddate,
        probationstartdate,
        contractstartdate,
        contractenddate,
        practicaltrainings,
        reportingmanager,
      } = formValues;

      const workexperienceDetails = workexperience?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
        };
      });

      const transformedEducationDetails = educationdetails?.map((item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId
            ? att?.response?.uniqueId
            : att?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
          attachment: updatedAttachment || [],
        };
      });

      const practicaltrainingsDetails = practicaltrainings?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
        };
      });

      const professionalcertificationsDetails = professionalcertifications?.map(
        (item) => {
          const { attachment, fromdate, todate, ...rest } = item;
          const updatedAttachment = attachment?.map((att) => ({
            name: att?.name,
            uniqueId: att?.response?.uniqueId
              ? att?.response?.uniqueId
              : att?.uniqueId,
          }));
          return {
            ...rest,
            fromdate: moment(fromdate).format("YYYY-MM-DD"),
            todate: moment(todate).format("YYYY-MM-DD"),
            attachment: updatedAttachment,
          };
        }
      );

      const roleNames = roleList
        .filter((item) => selectedRoleId?.includes(item.roleId))
        .map((item) => item.roleName);

      const dobDate = new Date(dateof_birth);
      const currentDate = new Date();
      const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();

      const response = await CALL_API(`add-users/${ClientId}`, "patch", {
        user_id: user_id?.toLowerCase(),
        full_name: `${firstname} ${lastname}`,
        end_date: formValues?.start_date
          ? moment(formValues?.start_date?._d).format("YYYY-MM-DD")
          : "",
        start_date: start_date
          ? moment(start_date?._d).format("YYYY-MM-DD")
          : "",
        overtime_status: overtime,
        bandname: EmployeeDetails?.bandname,
        bandid: EmployeeDetails?.bandid,
        gender: gender,
        dateofbirth: dateof_birth
          ? moment(dateof_birth?._d).format("YYYY-MM-DD")
          : "",
        age: agecalculte,
        password: password,
        maritalstatus: maritalstatus,
        employeenumber: employeenumber,
        nationality: nationality,
        salary: salary,
        role_id: selectedRoleId,
        role_name: roleNames ? roleNames : "",
        nssf: nssf,
        national_id: national_id,
        krapin: krapin,
        sharegnum: sharegnum,
        driverslicense: driverslicense,
        contract: contract,
        phoneno: phoneno,
        address: address,
        permanentaddress: address,
        presentaddress: address,
        employementtype: employementtype,
        profile_url: EmployeeDetails?.profileurl,
        companyname: companyname,
        jobtitle: jobtitle,
        professionalsince: professionalsince
          ? moment(professionalsince?._d).format("YYYY-MM-DD")
          : "",
        hireddate: hireddate ? moment(hireddate?._d).format("YYYY-MM-DD") : "",
        probationstartdate: probationstartdate
          ? moment(probationstartdate?._d, "YYYY-MM-DD")
          : "",
        probationenddate: probationenddate
          ? moment(probationenddate?._d, "YYYY-MM-DD")
          : "",
        contractstartdate: contractstartdate
          ? moment(contractstartdate?._d, "YYYY-MM-DD")
          : "",
        contractenddate: contractenddate
          ? moment(contractenddate?._d, "YYYY-MM-DD")
          : "",
        relevant: relevent,
        employeesponser: employeesponser,
        statusname: employeestatus,
        status_id: EmployeeDetails?.statusid,
        jobdescription: description,
        emergencycontactname: emergencycontactname,
        emergencycontactnumber: emergencycontactnumber,
        baselocationid: baseLocation,
        basedepartmentid: baseDepartment,
        employeeid: employeeid,
        initial: initial,
        firstname: firstname,
        lastname: lastname,
        salutation: salutation,
        lastpromotionlevel: lastpromotionlevel,
        lastpromotiondate: lastpromotiondate ? moment(lastpromotiondate) : "",
        reportingmanager: reportingmanager,
        educationdetails: transformedEducationDetails,
        workexperience: workexperienceDetails,
        professionalcertifications: professionalcertificationsDetails,
        practicaltrainings: practicaltrainingsDetails,
      });

      toggleLoader(false);
      form.resetFields();

      if (response.code === "SUCCESS") {
        if (response?.message === "Please Upgrade Your Plan") {
          message.error(response?.message);
        } else {
          message.success(response?.message);
          setUpdateState("");
        }
      }
      setUpdateState("");
      await fetchMasterData(true);
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  const tabTitles = [
    t("Basic"),
    // t("Permission"),
    t("Location"),
    t("Department"),
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const rolecolumns = [
    {
      title: t("Role Name"),
      dataIndex: "roleName",
      key: "roleName",
      width: "10%",
    },
    {
      title: t("Access Level"),
      dataIndex: "roleId",
      key: "roleId",
      width: "10%",
      align: "center",
      render: (roleId) => {
        const check = selectedRoleId?.includes(roleId) ? true : false;
        return (
          <Switch
            size="small"
            defaultChecked
            checked={check}
            onChange={(checked) => {
              getRoleId(roleId, checked);
            }}
          />
        );
      },
    },
  ];

  const baseLocationColumn = [
    {
      title: t("Select Base Location"),
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => (
        <Switch
          size="small"
          checked={baseLocation === location_id}
          onChange={(checked) => {
            setBaseLocation(checked ? location_id : "");
            onFinish();
          }}
        />
      ),
    },
  ];

  const baseDepartmentColumn = [
    {
      title: t("Select Base Department"),
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => (
        <Switch
          size="small"
          checked={baseDepartment === department_id}
          onChange={(checked) => {
            setBaseDepartment(checked ? department_id : "");
            onFinish();
          }}
        />
      ),
    },
  ];

  const getRoleId = (role_id, checked) => {
    const newRoleId = checked
      ? [...selectedRoleId, role_id]
      : selectedRoleId.filter((item) => item !== role_id);
    setSelectedRoleId(newRoleId);
    onFinish();
  };

  const handleSelectAllRole = (e) => {
    const checked = e.target.checked;
    setSelectAllRoleChecked(checked);
    const allRoleIds = roleList.map((item) => item.roleId);
    setSelectedRoleId(checked ? allRoleIds : []);
    setFormValues((prev) => ({ ...prev, selectedRoleId: selectedRoleId }));
    onFinish();
  };

  const handleResetAllRole = (e) => {
    setSelectedRoleId([]);
    setFormValues((prev) => ({ ...prev, selectedRoleId: selectedRoleId }));
    onFinish();
  };

  useEffect(() => {
    setSelectedRoleId(EmployeeDetails.roleid);
    setBaseLocation(
      EmployeeDetails?.baselocationid ? EmployeeDetails?.baselocationid : ""
    );
    setBaseDepartment(
      EmployeeDetails?.basedepartmentid ? EmployeeDetails?.basedepartmentid : ""
    );
  }, [EmployeeDetails]);

  const locationId = chain(roleList)
    .filter((role) => selectedRoleId?.includes(role.roleId))
    .flatMap((role) => role.locationId)
    .uniq()
    .value();

  const locationBasedOnRole = locationList?.filter((val) =>
    locationId.includes(val?.location_id)
  );
  const filterLocationList = locationBasedOnRole?.filter(
    (item) => item?.login_from_anywhere !== 1
  );

  const departmentId = chain(roleList)
    .filter((role) => selectedRoleId?.includes(role.roleId))
    .flatMap((role) => role.department)
    .uniq()
    .value();

  const departmentBasedOnRole = allDepartmentList?.filter((val) =>
    departmentId.includes(val?.department_id)
  );

  const iconsize = { fontSize: "14px" };
  const cursorstyle = { cursor: "pointer" };

  return (
    <EditProfileBox>
      {/* ─── Edit Personal Information ─── */}
      {updateState === "personalinformation" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Personal Information")}:</b>
          <Form
            form={form}
            name="addemployeeform"
            layout="vertical"
            initialValues={{
              user_id: "",
              department_id: "",
              gender: "",
              dateof_birth: "",
              maritalstatus: "",
              nationality: "",
              nssf: "",
              national_id: "",
              employeenumber: "",
              krapin: "",
              sharegnum: "",
              driverslicense: "",
              contract: "",
              address: "",
              phoneno: "",
              overtime: "",
              start_date: "",
              emergencycontactname: "",
              emergencycontactnumber: "",
              employementtype: "",
              initial: "",
              first_name: "",
              last_name: "",
              salutation: "",
              dependent: "",
            }}
            onFinish={() => {
              handlesubmit();
            }}
          >
            <StyleRow className="m-1 mt-2" gutter={20}>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="salutation"
                  label={t("Salutation")}
                  placeholder={t("Select Salutation")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Salutation is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select Salutation")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="Mr.">Mr.</Option>
                    <Option value="Dr.">Dr.</Option>
                    <Option value="Prof.">Prof.</Option>
                    <Option value="Ms.">Ms.</Option>
                    <Option value="Mrs.">Mrs.</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="initial"
                  label={t("Initial")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Initial is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Initial")}
                    maxLength={5}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="firstname"
                  label={t("First Name")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("First name is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("First name")}
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="lastname"
                  label={t("Last Name")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Last name is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Last name")}
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="employeeid"
                  label={t("Employee ID")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Employee ID is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Employee ID")}
                    maxLength={15}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z0-9\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="user_id"
                  label={t("Email ID")}
                  rules={[
                    { required: true, message: t("Email ID is required") },
                    { validator: validateEmployeeId },
                  ]}
                >
                  <Input
                    placeholder={t("Email ID")}
                    disabled={true}
                    onChange={onFinish}
                    maxLength={60}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="gender"
                  label={t("Gender")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Gender is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select gender")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="male">{t("Male")}</Option>
                    <Option value="female">{t("Female")}</Option>
                    <Option value="They/ Them">{t("They/ Them")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label={t("Date of Birth")}
                  name="dateof_birth"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Date of Birth is required"),
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    onChange={() => {
                      onFinish();
                    }}
                    placeholder={t("Select Date of Birth")}
                    getPopupContainer={() => containerRef.current}
                    disabledDate={(current) =>
                      current && current >= dayjs().startOf("day")
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="maritalstatus"
                  label={t("Marital Status")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("This field is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="single">{t("Single")}</Option>
                    <Option value="married">{t("Married")}</Option>
                    <Option value="widow">{t("Widow")}</Option>
                    <Option value="divorced">{t("Divorced")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="nationality"
                  label={t("Country")}
                  rules={[
                    { required: false, message: t("Country is required") },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder={t("Search to Select")}
                    optionFilterProp="children"
                    onChange={() => {
                      onFinish();
                      form.setFieldValue("phone", "");
                      form.setFieldValue("emergencycontactnumber", "");
                    }}
                    getPopupContainer={() => containerRef.current}
                  >
                    {countryList?.map((country, index) => (
                      <Select.Option
                        key={index}
                        value={country}
                        label={country}
                      >
                        {country}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item name="phoneno" label={t("Phone No")}>
                  <PhoneInput
                    type="text"
                    defaultCountry={
                      form.getFieldValue("nationality")
                        ? getCountryCodeByName(
                            form.getFieldValue("nationality")
                          )
                        : ""
                    }
                    placeholder={t("Phone No")}
                    maxLength={
                      form.getFieldValue("nationality")
                        ? Number(
                            getMaxLengthByCountry(
                              form.getFieldValue("nationality")
                            )
                          ) + 2
                        : 15
                    }
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value = /^[0-9+]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9+]$/)
                        e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="emergencycontactname"
                  label={t("Emergency Contact Name")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Emergency Contact Name is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Emergency Contact Name")}
                    maxLength={15}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="emergencycontactnumber"
                  label={t("Emergency Contact Number")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Emergency Contact Number is required"),
                    },
                  ]}
                >
                  <PhoneInput
                    placeholder={t("Emergency Contact Number")}
                    defaultCountry={
                      form.getFieldValue("nationality")
                        ? getCountryCodeByName(
                            form.getFieldValue("nationality")
                          )
                        : ""
                    }
                    maxLength={
                      form.getFieldValue("nationality")
                        ? Number(
                            getMaxLengthByCountry(
                              form.getFieldValue("nationality")
                            )
                          ) + 2
                        : 15
                    }
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value = /^[0-9+]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9+]$/)
                        e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label={t("NSSF")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("NSSF is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("NSSF")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/)
                        e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="national_id"
                  label={t("National ID")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("National ID is required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("National ID")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/)
                        e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="krapin"
                  label={t("kra_pin")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("kra_pin_required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("kra_pin")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/.test(e.key) || /^[a-zA-Z\s]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="sharegnum"
                  label={t("sha_registration_number")}
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("sha_registration_number_required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("sha_registration_number")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
  const value =
    /^[0-9]$/.test(e.key) ||
    /^[a-zA-Z\s\-/._#()]+$/.test(e.key);

  if (!value && e.key !== "Backspace") {
    e.preventDefault();
  }
}}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="driverslicense"
                  label={t("drivers_license")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("drivers_license_required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("drivers_license")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/.test(e.key) || /^[a-zA-Z\s]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="contract"
                  label={t("contract")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("contract_required"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("contract")}
                    maxLength={20}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/.test(e.key) || /^[a-zA-Z\s]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="address"
                  label={t("Address")}
                  rules={[
                    { required: false, message: t("Address is required") },
                  ]}
                >
                  <Input
                    placeholder={t("Address")}
                    onChange={onFinish}
                    maxLength={60}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9,/]$/.test(e.key) ||
                        /^[a-zA-Z\s,/]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Role Name"
                  name="role_id"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Please Select",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Role"
                    name="roleid"
                    options={roleList}
                    fieldNames={{
                      label: "roleName",
                      value: "roleId",
                    }}
                    onChange={(values) => {
                      onFinish();
                      setSelectedRoleId([values]);
                    }}
                    getPopupContainer={() =>
                      containerRef.current || document.body
                    }
                  />
                </Form.Item>
              </Col> */}
            </StyleRow>
            <div className="text-end mt-3">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}

      {/* ─── Edit Work Information ─── */}
      {updateState === "workinformation" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Work Information")}:</b>
          <Form
            form={form}
            name="addemployeeidentityform"
            layout="vertical"
            initialValues={{
              company_Name: "",
              jobtitle: "",
              professionalsince: "",
              hireddate: "",
              employeesponser: "",
              relevent: "",
              maritalstatus: "",
              description: "",
              lastpromotionlevel: "",
              overtime: "",
              lastpromotiondate: "",
              employementtype: "",
              probationstartdate: "",
              probationenddate: "",
              contractstartdate: "",
              contractenddate: "",
            }}
            onFinish={() => handlesubmit()}
          >
            <StyleRow className="m-1 mt-2" gutter={20}>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="overtime"
                  label={t("Overtime Eligible")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("This field is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="yes">{t("Yes")}</Option>
                    <Option value="no">{t("No")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="companyname"
                  label={t("Company Name")}
                  rules={[
                    { required: false, message: t("Company name is required") },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder={t("Company name")}
                    maxLength={50}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label={t("Last Promotion Date")}
                  name="lastpromotiondate"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Last Promotion Date is required"),
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder={t("Select Last Promotion Date")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="lastpromotionlevel"
                  label={t("Last Promotion Level")}
                  rules={[
                    {
                      required: false,
                      message: t("Last Promotion is required"),
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder={t("Last Promotion")}
                    maxLength={100}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="jobtitle"
                  label={t("Job Title")}
                  rules={[
                    { required: true, message: t("Job title is required") },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder={t("Job Title")}
                    maxLength={50}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label={t("Professional Since")}
                  name="professionalsince"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Professional Since is required"),
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    onChange={onFinish}
                    placeholder={t("Professional Since")}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label={t("Hired Date")}
                  name="hireddate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Hired Date is required"),
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    onChange={onFinish}
                    placeholder={t("Select Hired Date")}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="employeesponser"
                  label={t("Employee Sponsor")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Employee Sponsor is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="yes">{t("Yes")}</Option>
                    <Option value="no">{t("No")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="relevent"
                  label={t("Relevant")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Relevant is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select")}
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                  >
                    <Option value="yes">{t("Yes")}</Option>
                    <Option value="no">{t("No")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="employementtype"
                  label={t("Employment Type")}
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: t("Employment Type is required"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("Select")}
                    getPopupContainer={() => containerRef.current}
                    onChange={(value) => {
                      onFinish();
                      if (value !== "Probation") {
                        form.setFieldValue("probationstartdate", "");
                        form.setFieldValue("probationenddate", "");
                      }
                      if (value !== "Contract") {
                        form.setFieldValue("contractstartdate", "");
                        form.setFieldValue("contractenddate", "");
                      }
                    }}
                  >
                    <Option value="Casual">{t("Casual")}</Option>
                    <Option value="Contract">{t("Contract")}</Option>
                    <Option value="Full time">{t("Full time")}</Option>
                    <Option value="Paid Internship">
                      {t("Paid Internship")}
                    </Option>
                    <Option value="Part time">{t("Part time")}</Option>
                    <Option value="Training">{t("Training")}</Option>
                    <Option value="Unpaid Internship">
                      {t("Unpaid Internship")}
                    </Option>
                    <Option value="Probation">{t("Probation")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              {form.getFieldValue("employementtype") === "Probation" && (
                <>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={t("Probation Start Date")}
                      name="probationstartdate"
                      rules={[
                        {
                          required: true,
                          pattern: NON_EMPTY_REGEX,
                          message: t("Probation Start Date is required"),
                        },
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        placeholder={t("Select Probation start date")}
                        getPopupContainer={() => containerRef.current}
                        onChange={onFinish}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={t("Probation End Date")}
                      name="probationenddate"
                      rules={[
                        {
                          required: true,
                          pattern: NON_EMPTY_REGEX,
                          message: t("Probation End Date is required"),
                        },
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        placeholder={t("Select Probation End date")}
                        getPopupContainer={() => containerRef.current}
                        onChange={onFinish}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {form.getFieldValue("employementtype") === "Contract" && (
                <>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={t("Contract Start Date")}
                      name="contractstartdate"
                      rules={[
                        {
                          required: false,
                          pattern: NON_EMPTY_REGEX,
                          message: t("Contract Start Date is required"),
                        },
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        placeholder={t("Select Contract start date")}
                        getPopupContainer={() => containerRef.current}
                        onChange={onFinish}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={t("Contract End Date")}
                      name="contractenddate"
                      rules={[
                        {
                          required: false,
                          pattern: NON_EMPTY_REGEX,
                          message: t("Contract End Date is required"),
                        },
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        placeholder={t("Select Contract End date")}
                        getPopupContainer={() => containerRef.current}
                        onChange={onFinish}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="employeenumber"
                            label="Employee Number"
                          >
                            <Input
                              type="text"
                              placeholder="Employee Number"
                              maxLength={20}
                              // onKeyDown={(e) => {
                              //   const value = /^[0-9]$/?.test(e.key);
                              //   if (
                              //     !value &&
                              //     e.key !== "Backspace" &&
                              //     e.key !== "Tab" &&
                              //     /^[0-9]$/
                              //   ) {
                              //     e.preventDefault();
                              //   }
                              // }}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item name="description" label={t("Description")}>
                  <Input.TextArea
                    onChange={onFinish}
                    placeholder={t("description")}
                  />
                </Form.Item>
              </Col>
            </StyleRow>
            <div className="text-end mt-3">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}

      {/* ─── Edit Employee (Basic Tab) ─── */}
      {updateState === "basic" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {" "}
            {pageName} /
          </button>{" "}
          <b>{t("Edit Employee")}</b>
          <Tabs
            defaultActiveKey={activeTab}
            className="mt-3"
            onChange={handleTabChange}
          >
            {tabTitles.map((title, index) => (
              <TabPane tab={title} key={index.toString()}>
                {activeTab === "0" && (
                  <>
                    <Form
                      form={form}
                      name="addemployeeform"
                      layout="vertical"
                      initialValues={{
                        user_id: "",
                        department_id: "",
                        gender: "",
                        dateof_birth: "",
                        maritalstatus: "",
                        nationality: "",
                        nssf: "",
                        national_id: "",
                        krapin: "",
                        sharegnum: "",
                        driverslicense: "",
                        contract: "",
                        address: "",
                        phoneno: "",
                        overtime: "",
                        start_date: "",
                        emergencycontactname: "",
                        emergencycontactnumber: "",
                        employementtype: "",
                        initial: "",
                        first_name: "",
                        last_name: "",
                        salutation: "",
                        jobtitle: "",
                        professionalsince: "",
                        hireddate: "",
                        employeesponser: "",
                        relevent: "",
                        description: "",
                        lastpromotionlevel: "",
                        lastpromotiondate: "",
                        probationstartdate: "",
                        probationenddate: "",
                        contractstartdate: "",
                        contractenddate: "",
                        reportingmanager: "",
                      }}
                      onFinish={() => {
                        handlesubmit();
                      }}
                    >
                      <b className="my-2">{t("Edit Work Information")}:</b>
                      <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="overtime"
                            label={t("Overtime Eligible")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("This field is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="yes">{t("Yes")}</Option>
                              <Option value="no">{t("No")}</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="companyname"
                            label={t("Company Name")}
                            rules={[
                              {
                                required: false,
                                message: t("Company name is required"),
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              placeholder={t("Company name")}
                              maxLength={50}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            label={t("Last Promotion Date")}
                            name="lastpromotiondate"
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Last Promotion Date is required"),
                              },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("Select Last Promotion Date")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="lastpromotionlevel"
                            label={t("Last Promotional Level")}
                            rules={[
                              {
                                required: false,
                                message: t("Last Promotion is required"),
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              placeholder={t("Last Promotion")}
                              maxLength={100}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="jobtitle"
                            label={t("Job Title")}
                            rules={[
                              {
                                required: true,
                                message: t("Job title is required"),
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              placeholder={t("Job Title")}
                              maxLength={50}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            label={t("Professional Since")}
                            name="professionalsince"
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Professional Since is required"),
                              },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={onFinish}
                              placeholder={t("Professional Since")}
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            label={t("Hired Date")}
                            name="hireddate"
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Hired Date is required"),
                              },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={onFinish}
                              placeholder={t("Select Hired Date")}
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="employeesponser"
                            label={t("Employee Sponsor")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Employee Sponsor is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="yes">{t("Yes")}</Option>
                              <Option value="no">{t("No")}</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="relevent"
                            label={t("Relevant")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Relevant is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="yes">{t("Yes")}</Option>
                              <Option value="no">{t("No")}</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="employementtype"
                            label={t("Employment Type")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Employment Type is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                              onChange={(value) => {
                                onFinish();
                                if (value !== "Probation") {
                                  form.setFieldValue("probationstartdate", "");
                                  form.setFieldValue("probationenddate", "");
                                }
                                if (value !== "Contract") {
                                  form.setFieldValue("contractstartdate", "");
                                  form.setFieldValue("contractenddate", "");
                                }
                              }}
                            >
                              <Option value="Casual">{t("Casual")}</Option>
                              <Option value="Contract">{t("Contract")}</Option>
                              <Option value="Full time">
                                {t("Full time")}
                              </Option>
                              <Option value="Paid Internship">
                                {t("Paid Internship")}
                              </Option>
                              <Option value="Part time">
                                {t("Part time")}
                              </Option>
                              <Option value="Training">{t("Training")}</Option>
                              <Option value="Unpaid Internship">
                                {t("Unpaid Internship")}
                              </Option>
                              <Option value="Probation">
                                {t("Probation")}
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {form.getFieldValue("employementtype") ===
                          "Probation" && (
                          <>
                            <Col xs={24} sm={24} md={12}>
                              <Form.Item
                                label={t("Probation Start Date")}
                                name="probationstartdate"
                                rules={[
                                  {
                                    required: true,
                                    pattern: NON_EMPTY_REGEX,
                                    message: t(
                                      "Probation Start Date is required"
                                    ),
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="w-100"
                                  format="DD-MM-YYYY"
                                  placeholder={t("Select Probation start date")}
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12}>
                              <Form.Item
                                label={t("Probation End Date")}
                                name="probationenddate"
                                rules={[
                                  {
                                    required: true,
                                    pattern: NON_EMPTY_REGEX,
                                    message: t(
                                      "Probation End Date is required"
                                    ),
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="w-100"
                                  format="DD-MM-YYYY"
                                  placeholder={t("Select Probation End date")}
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        {form?.getFieldValue("employementtype") ===
                          "Contract" && (
                          <>
                            <Col xs={24} sm={24} md={12} ref={containerRef}>
                              <Form.Item
                                label={t("Contract Start Date")}
                                name="contractstartdate"
                                rules={[
                                  {
                                    required: false,
                                    pattern: NON_EMPTY_REGEX,
                                    message: t(
                                      "Contract Start Date is required"
                                    ),
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="w-100"
                                  format="DD-MM-YYYY"
                                  placeholder={t("Select Contract start date")}
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} ref={containerRef}>
                              <Form.Item
                                label={t("Contract End Date")}
                                name="contractenddate"
                                rules={[
                                  {
                                    required: false,
                                    pattern: NON_EMPTY_REGEX,
                                    message: t("Contract End Date is required"),
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="w-100"
                                  format="DD-MM-YYYY"
                                  placeholder={t("Select Contract End date")}
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="description"
                            label={t("Description")}
                          >
                            <Input.TextArea
                              onChange={onFinish}
                              placeholder={t("description")}
                            />
                          </Form.Item>
                        </Col>
                      </StyleRow>

                      <b className="my-2">{t("Edit Personal Information")}:</b>
                      <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="salutation"
                            label={t("Salutation")}
                            placeholder={t("Select Salutation")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Salutation is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select Salutation")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="Mr.">Mr.</Option>
                              <Option value="Dr.">Dr.</Option>
                              <Option value="Prof.">Prof.</Option>
                              <Option value="Ms.">Ms.</Option>
                              <Option value="Mrs.">Mrs.</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="initial"
                            label={t("Initial")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Initial is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("Initial")}
                              maxLength={5}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="firstname"
                            label={t("First Name")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("First name is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("First name")}
                              maxLength={50}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="lastname"
                            label={t("Last Name")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Last name is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("Last name")}
                              maxLength={50}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="employeeid"
                            label={t("Employee ID")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Employee ID is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("Employee ID")}
                              maxLength={15}
                              disabled={true}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="user_id"
                            label={t("Email ID")}
                            rules={[
                              {
                                required: true,
                                message: t("Email ID is required"),
                              },
                              { validator: validateEmployeeId },
                            ]}
                          >
                            <Input
                              placeholder={t("Email ID")}
                              disabled={true}
                              onChange={onFinish}
                              maxLength={60}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="gender"
                            label={t("Gender")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Gender is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select gender")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="male">{t("Male")}</Option>
                              <Option value="female">{t("Female")}</Option>
                              <Option value="They/ Them">
                                {t("They/ Them")}
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            label={t("Date of Birth")}
                            name="dateof_birth"
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Date of Birth is required"),
                              },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder={t("Select Date of Birth")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="maritalstatus"
                            label={t("Marital Status")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("This field is required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="single">{t("Single")}</Option>
                              <Option value="married">{t("Married")}</Option>
                              <Option value="widow">{t("Widow")}</Option>
                              <Option value="divorced">{t("Divorced")}</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="reportingmanager"
                            label={t("Reporting Manager")}
                            rules={[
                              {
                                required: userList?.length !== 0 ? true : false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("Reporting Manager is required"),
                              },
                            ]}
                          >
                            <Select
                              className="selectbox mb-2"
                              showSearch
                              placeholder={t("Select Manager")}
                              options={userList?.filter(
                                (item) => item?.statusid === "1"
                              )}
                              fieldNames={{
                                label: "fullname",
                                value: "userid",
                              }}
                              filterOption={(input, option) =>
                                (option.fullname ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              filterSort={(a, b) =>
                                (a.fullname ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (b.fullname ?? "").toLowerCase()
                                  )
                              }
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="nationality"
                            label={t("Country")}
                            rules={[
                              {
                                required: false,
                                message: t("Country is required"),
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder={t("Search to Select")}
                              optionFilterProp="children"
                              onChange={() => {
                                onFinish();
                                form.setFieldValue("phone", "");
                                form.setFieldValue(
                                  "emergencycontactnumber",
                                  ""
                                );
                              }}
                              getPopupContainer={() => containerRef.current}
                            >
                              {countryList?.map((country, index) => (
                                <Select.Option
                                  key={index}
                                  value={country}
                                  label={country}
                                >
                                  {country}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item name="phoneno" label={t("Phone No")}>
                            <PhoneInput
                              type="text"
                              defaultCountry={
                                form.getFieldValue("nationality")
                                  ? getCountryCodeByName(
                                      form.getFieldValue("nationality")
                                    )
                                  : ""
                              }
                              placeholder={t("Phone No")}
                              maxLength={
                                form.getFieldValue("nationality")
                                  ? Number(
                                      getMaxLengthByCountry(
                                        form.getFieldValue("nationality")
                                      )
                                    ) + 2
                                  : 15
                              }
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value = /^[0-9+]$/?.test(e.key);
                                if (
                                  !value &&
                                  e.key !== "Backspace" &&
                                  /^[0-9+]$/
                                )
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="emergencycontactname"
                            label={t("Emergency Contact Name")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t(
                                  "Emergency Contact Name is required"
                                ),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("Emergency Contact Name")}
                              maxLength={15}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="emergencycontactnumber"
                            label={t("Emergency Contact Number")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t(
                                  "Emergency Contact Number is required"
                                ),
                              },
                            ]}
                          >
                            <PhoneInput
                              placeholder={t("Emergency Contact Number")}
                              defaultCountry={
                                form.getFieldValue("nationality")
                                  ? getCountryCodeByName(
                                      form.getFieldValue("nationality")
                                    )
                                  : ""
                              }
                              maxLength={
                                form.getFieldValue("nationality")
                                  ? Number(
                                      getMaxLengthByCountry(
                                        form.getFieldValue("nationality")
                                      )
                                    ) + 2
                                  : 15
                              }
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value = /^[0-9+]$/?.test(e.key);
                                if (
                                  !value &&
                                  e.key !== "Backspace" &&
                                  /^[0-9+]$/
                                )
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="nssf"
                            label={t("NSSF")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("NSSF is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("NSSF")}
                              maxLength={20}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9]$/?.test(e.key) ||
                                  /^[a-zA-Z\s]+$/?.test(e.key);
                                if (
                                  !value &&
                                  e.key !== "Backspace" &&
                                  /^[0-9]$/
                                )
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="national_id"
                            label={t("National ID")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("National ID is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("National ID")}
                              maxLength={20}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9]$/?.test(e.key) ||
                                  /^[a-zA-Z\s]+$/?.test(e.key);
                                if (
                                  !value &&
                                  e.key !== "Backspace" &&
                                  /^[0-9]$/
                                )
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="krapin"
                            label={t("kra_pin")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("kra_pin_required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("kra_pin")}
                              maxLength={20}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9]$/.test(e.key) ||
                                  /^[a-zA-Z\s]+$/.test(e.key);
                                if (!value && e.key !== "Backspace") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="sharegnum"
                            label={t("sha_registration_number")}
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: t("sha_registration_number_required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("sha_registration_number")}
                              maxLength={20}
                              onChange={onFinish}
                             onKeyDown={(e) => {
  const value =
    /^[0-9]$/.test(e.key) ||
    /^[a-zA-Z\s\-/._#()]+$/.test(e.key);

  if (!value && e.key !== "Backspace") {
    e.preventDefault();
  }
}}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="driverslicense"
                            label={t("drivers_license")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("drivers_license_required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("drivers_license")}
                              maxLength={20}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9]$/.test(e.key) ||
                                  /^[a-zA-Z\s]+$/.test(e.key);
                                if (!value && e.key !== "Backspace") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="contract"
                            label={t("contract")}
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: t("contract_required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("contract")}
                              maxLength={20}
                              onChange={onFinish}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9]$/.test(e.key) ||
                                  /^[a-zA-Z\s]+$/.test(e.key);
                                if (!value && e.key !== "Backspace") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="address"
                            label={t("Address")}
                            rules={[
                              {
                                required: false,
                                message: t("Address is required"),
                              },
                            ]}
                          >
                            <Input
                              placeholder={t("Address")}
                              onChange={onFinish}
                              maxLength={60}
                              onKeyDown={(e) => {
                                const value =
                                  /^[0-9,/]$/.test(e.key) ||
                                  /^[a-zA-Z\s,/]+$/.test(e.key);
                                if (!value && e.key !== "Backspace")
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            label="Role Name"
                            name="role_id"
                            rules={[
                              {
                                required: true,
                                pattern: NON_EMPTY_REGEX,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Role"
                              name="roleid"
                              options={roleList}
                              fieldNames={{
                                label: "roleName",
                                value: "roleId",
                              }}
                              onChange={(values) => {
                                onFinish();
                                setSelectedRoleId([values]);
                              }}
                              getPopupContainer={(trigger) =>
                                trigger?.parentElement || document.body
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            name="employeenumber"
                            label="Employee Number"
                          >
                            <Input
                              type="text"
                              placeholder="Employee Number"
                              maxLength={20}
                              // onKeyDown={(e) => {
                              //   const value = /^[0-9]$/?.test(e.key);
                              //   if (
                              //     !value &&
                              //     e.key !== "Backspace" &&
                              //     e.key !== "Tab" &&
                              //     /^[0-9]$/
                              //   ) {
                              //     e.preventDefault();
                              //   }
                              // }}
                              onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                      </StyleRow>
                      <div className="text-end mt-3">
                        <StyledButton
                          loading={showLoader}
                          type="primary"
                          htmlType="submit"
                        >
                          {showLoader ? t("Update") : t("Update")}
                        </StyledButton>
                      </div>
                    </Form>
                  </>
                )}

                {/* {activeTab === "1" && (
                  <div className="styled-card mb-5">
                    {roleList.length === 0 && (
                      <StyledButton className="mt-2">
                        {t("Add Role")}
                      </StyledButton>
                    )}
                    {roleList?.length > 0 && (
                      <Checkbox
                        className="mt-3"
                        checked={selectAllRoleChecked}
                        onChange={handleSelectAllRole}
                      >
                        {t("Select All")}
                      </Checkbox>
                    )}
                    <SelectTable
                      columns={rolecolumns}
                      tabledata={roleList}
                      handleClickRole={handlesubmit}
                      handleReset={handleResetAllRole}
                      selectedRoleId={selectedRoleId}
                      showLoader={showLoader}
                    />
                  </div>
                )} */}

                {activeTab === "1" && (
                  <>
                    {filterLocationList?.length === 0 ? (
                      <div className="free-trial-banner">
                        <span className="content">
                          {t(
                            "Kindly assign the location for the selected role or select another role"
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className="styled-card mb-5">
                        <SelectTable
                          columns={baseLocationColumn}
                          tabledata={filterLocationList}
                          editRole="edit"
                          handleClickRole={handlesubmit}
                          selectedBaseLocation={baseLocation}
                          showLoader={showLoader}
                        />
                      </div>
                    )}
                  </>
                )}

                {activeTab === "2" && (
                  <>
                    {departmentBasedOnRole?.length === 0 ? (
                      <div className="free-trial-banner">
                        <span className="content">
                          {t(
                            "Kindly assign the department for the selected role or select another role"
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className="styled-card mb-5">
                        <SelectTable
                          columns={baseDepartmentColumn}
                          tabledata={departmentBasedOnRole}
                          editRole="edit"
                          handleClickRole={handlesubmit}
                          selectedBaseDepartment={baseDepartment}
                          showLoader={showLoader}
                        />
                      </div>
                    )}
                  </>
                )}
              </TabPane>
            ))}
          </Tabs>
        </>
      )}

      {/* ─── Edit Education Details ─── */}
      {updateState === "educationdetails" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Education Details")}:</b>
          <Form
            form={form}
            name="dynamic_form_nest_item"
            onFinish={(values) => {
              handlesubmit();
            }}
            autoComplete="off"
            initialValues={{ educationdetails: [] }}
            labelCol={{ xs: 24, sm: 24, md: 24 }}
            style={{ textAlign: "left" }}
          >
            <Form.List name="educationdetails">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <StyleRow gutter={16} className="mt-2" key={key}>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Institute Name")}
                          name={[name, "institutename"]}
                          rules={[
                            {
                              required: false,
                              message: t("Institute Name required"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Institute Name")}
                            onChange={onFinish}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("From")}
                          name={[name, "fromdate"]}
                          rules={[
                            { required: false, message: t("Date required") },
                          ]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("From")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("To")}
                          name={[name, "todate"]}
                          rules={[
                            { required: false, message: t("Date required") },
                          ]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("To")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          label={t("Exam Body:")}
                          name={[name, "exambody"]}
                          rules={[
                            {
                              required: false,
                              message: t("Exam Body required"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Exam Body")}
                            onChange={onFinish}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          label={t("Awarded")}
                          name={[name, "awarded"]}
                          rules={[
                            { required: false, message: t("Awarded required") },
                          ]}
                        >
                          <Select
                            placeholder={t("Select")}
                            getPopupContainer={() => containerRef.current}
                            onChange={onFinish}
                          >
                            <Option value="Doctorate">{t("Doctorate")}</Option>
                            <Option value="Master">{t("Master")}</Option>
                            <Option value="Bachelor">{t("Bachelor")}</Option>
                            <Option value="Diploma">{t("Diploma")}</Option>
                            <Option value="Certificate">
                              {t("Certificate")}
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Attachment")}
                          name={[name, "attachment"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            if (Array.isArray(e)) return e;
                            return e && e.fileList;
                          }}
                        >
                          <Upload
                            customRequest={({ file, onSuccess }) => {
                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                const base64Data = reader.result.split(",")[1];
                                const uniqueId = generateUniqueId();
                                onSuccess({ file, base64Data, uniqueId });
                              };
                              reader.onerror = (error) =>
                                console.error("File read error:", error);
                            }}
                            name="logo"
                            listType="picture"
                            style={{ width: "100%" }}
                            onChange={(value) => {
                              onFinish();
                              uploadFile(value);
                            }}
                            maxCount={1}
                          >
                            <div style={{ width: "100%" }}>
                              <Button className="w-100 text-start" size="large">
                                {t("Upload File")}
                              </Button>
                            </div>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </StyleRow>
                  ))}
                  <Form.Item>
                    <u
                      className="bg-transparent border-0 text-start"
                      type="dashed"
                      onClick={() => add()}
                      block
                      style={cursorstyle}
                    >
                      {t("+Add Another")}
                    </u>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <div className="text-end">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}

      {/* ─── Edit Practical Training ─── */}
      {updateState === "practicaltrainings" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Practical Training")}:</b>
          <Form
            form={form}
            name="dynamic_form_nest_item"
            onFinish={(values) => {
              handlesubmit();
            }}
            autoComplete="off"
            initialValues={{ practicaltrainings: [] }}
            labelCol={{ xs: 24, sm: 24, md: 24 }}
            style={{ textAlign: "left" }}
          >
            <Form.List name="practicaltrainings">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <StyleRow gutter={16} className="mt-2" key={key}>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Organisation Name")}
                          name={[name, "organisationname"]}
                        >
                          <Input
                            placeholder={t("Organisation Name")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("From")}
                          name={[name, "fromdate"]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("From")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("To")}
                          name={[name, "todate"]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("To")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Position Held")}
                          name={[name, "positionheld"]}
                        >
                          <Input
                            placeholder={t("Position Held")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t(
                            "Nature of work & Tasks performed or completed"
                          )}
                          name={[name, "tasksperformed"]}
                        >
                          <Input.TextArea
                            placeholder={t(
                              "Nature of work & Tasks performed or completed"
                            )}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </StyleRow>
                  ))}
                  <Form.Item>
                    <u
                      className="bg-transparent border-0 text-start"
                      type="dashed"
                      onClick={() => add()}
                      block
                      style={cursorstyle}
                    >
                      {t("+Add Another")}
                    </u>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <div className="text-end">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}

      {/* ─── Edit Work Experience ─── */}
      {updateState === "workexperience" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Work Experience")}:</b>
          <Form
            form={form}
            name="dynamic_form_nest_item"
            onFinish={(values) => {
              handlesubmit();
            }}
            autoComplete="off"
            initialValues={{ workexperience: [] }}
            labelCol={{ xs: 24, sm: 24, md: 24 }}
            style={{ textAlign: "left" }}
          >
            <Form.List name="workexperience">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <StyleRow gutter={16} className="mt-2" key={key}>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          label={t("Company name")}
                          name={[name, "companyname"]}
                          rules={[
                            {
                              required: true,
                              message: t("Company name required"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Company name")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          {...restField}
                          label={t("Job Title")}
                          name={[name, "jobtitle"]}
                          rules={[
                            {
                              required: true,
                              message: t("Job Title required"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Job Title")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("From")}
                          name={[name, "fromdate"]}
                          rules={[
                            { required: true, message: t("Date required") },
                          ]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("From")}
                            getPopupContainer={() => containerRef.current}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("To")}
                          name={[name, "todate"]}
                          rules={[
                            { required: true, message: t("Date required") },
                          ]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("To")}
                            getPopupContainer={() => containerRef.current}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Relevant")}
                          name={[name, "relevant"]}
                          rules={[
                            { required: true, message: t("Relevant required") },
                          ]}
                        >
                          <Select
                            placeholder={t("Select")}
                            getPopupContainer={() => containerRef.current}
                            onChange={onFinish}
                          >
                            <Option value="yes">{t("Yes")}</Option>
                            <Option value="no">{t("No")}</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Job Description")}
                          name={[name, "jobdescription"]}
                          rules={[
                            {
                              required: true,
                              message: t("Job Description required"),
                            },
                          ]}
                        >
                          <Input.TextArea
                            placeholder={t("Job Description")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </StyleRow>
                  ))}
                  <Form.Item>
                    <u
                      className="bg-transparent border-0 text-start"
                      type="dashed"
                      onClick={() => add()}
                      block
                      style={cursorstyle}
                    >
                      {t("+Add Another")}
                    </u>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <div className="text-end">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}

      {/* ─── Edit Professional Certification ─── */}
      {updateState === "professionalcertifications" && (
        <>
          <button
            className="bg-transparent border-0"
            onClick={() => setUpdateState("")}
          >
            {pageName} /{" "}
          </button>
          <b>{t("Edit Professional Certification")}:</b>
          <Form
            form={form}
            name="dynamic_form_nest_item"
            onFinish={(values) => {
              handlesubmit();
            }}
            autoComplete="off"
            initialValues={{ professionalcertifications: [] }}
            labelCol={{ xs: 24, sm: 24, md: 24 }}
            style={{ textAlign: "left" }}
          >
            <Form.List name="professionalcertifications">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <StyleRow gutter={16} className="mt-2" key={key}>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Certification Type")}
                          name={[name, "certificationtype"]}
                        >
                          <Select
                            showSearch
                            placeholder={t("Select")}
                            optionFilterProp="children"
                            getPopupContainer={() => containerRef.current}
                            defaultValue={AwardList[0]}
                            onChange={() => {
                              onFinish();
                            }}
                          >
                            {AwardList?.map((value, index) => (
                              <Select.Option
                                key={index}
                                value={value}
                                label={value}
                              >
                                {value}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("From")}
                          name={[name, "fromdate"]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("From")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} ref={containerRef}>
                        <Form.Item
                          {...restField}
                          label={t("To")}
                          name={[name, "todate"]}
                        >
                          <DatePicker
                            className="w-100"
                            format="DD-MM-YYYY"
                            onChange={() => {
                              onFinish();
                            }}
                            placeholder={t("To")}
                            getPopupContainer={() => containerRef.current}
                            disabledDate={(current) =>
                              current && current >= dayjs().startOf("day")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Remarks")}
                          name={[name, "remarks"]}
                        >
                          <Input
                            placeholder={t("Remarks")}
                            onChange={() => {
                              onFinish();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          {...restField}
                          label={t("Attachment")}
                          name={[name, "attachment"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            if (Array.isArray(e)) return e;
                            return e && e.fileList;
                          }}
                        >
                          <Upload
                            customRequest={({ file, onSuccess }) => {
                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                const base64Data = reader.result.split(",")[1];
                                const uniqueId = generateUniqueId();
                                onSuccess({ file, base64Data, uniqueId });
                              };
                              reader.onerror = (error) =>
                                console.error("File read error:", error);
                            }}
                            name="logo"
                            onChange={(value) => {
                              onFinish();
                              uploadFile(value);
                            }}
                            listType="picture"
                            style={{ width: "100%" }}
                          >
                            <div style={{ width: "100%" }}>
                              <Button className="w-100 text-start" size="large">
                                {t("Upload File")}
                              </Button>
                            </div>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </StyleRow>
                  ))}
                  <Form.Item>
                    <u
                      className="bg-transparent border-0 text-start"
                      type="dashed"
                      onClick={() => add()}
                      block
                      style={cursorstyle}
                    >
                      {t("+Add Another")}
                    </u>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <div className="text-end">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                {showLoader ? t("Update") : t("Update")}
              </StyledButton>
            </div>
          </Form>
        </>
      )}
    </EditProfileBox>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { updateUserList: setUserList, saveRoleList: setRoleList },
    dispatch
  );

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  roleList: getRoleList(state),
  ClientId: getClientid(state),
  bandList: getBandList(state),
  locationList: getLocations(state),
  allDepartmentList: getAllDepartmentList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, mapDispatchToProps, null)(EditProfile);
